import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { AbstractBean } from '@app/core/model/abstract-bean';
import { AssetType } from '@app/core/model/entities/asset/asset-type';
import { FieldConfigInput, FormNode } from '@app/core/model/other/field-config';
import { ColumnGroup } from '@app/core/model/other/grid-config';
import { Expose, Type } from 'class-transformer';

/**
 * ImportTemplateInput for updating ImportTemplates.
 */
export interface UpdateImportTemplateInput {
  customOptions?: Record<string, any>;
  columnGroups?: ColumnGroupInput[];
}
export interface ColumnGroupInput {
  code: string;
  label: string;
  order: number;
  assetType?: AssetType;
  customOptions?: Record<string, any>;
  columns?: FieldConfigInput[];
}
export class ImportTemplate extends AbstractBean implements FormNode {
  public code: string;
  public entityType: EntityTypeEnum;

  public customOptions?: Record<string, any>;

  @Expose({name: 'columnGroupsList'})
  @Type(() => ColumnGroup)
  public children: ColumnGroup[];

  @Expose({name: '__typename'})
  public graphQlTypeName: string;

  public get label(): string {
    return `MENU.${this.entityType}_IMPORT_TEMPLATE`;
  }
}
